import { Base, DataReceiveEvent, TimeoutEvent } from "@gaming/srvg-classes-core";
import { DesktopView } from "./View/AppView/DesktopView";
import * as SrvgCore from '@gaming/srvg-classes-core';
import * as Vf from '../VfModule';
import * as VfWidgets from '../widgets/VfWidgetLibrary';



// DesktopLayoutTemplateParser a.k.a. LTE parser
export class DesktopLayoutTemplateParser extends Base {
    retryTimeOnErrorInMs:number;
    defaultModuleName:string;
    desktopView:DesktopView;
    elementsIndex:number;

    constructor(options) {
        options = options || {};
        super(options);
        this.retryTimeOnErrorInMs = 2000;
        this.defaultModuleName = options.defaultModuleName || 'Srvg';
        this.generatedEvents.push(DataReceiveEvent);
        this.elementsIndex = 0;
    }

    initialize(selector) {
        var desktopViewsToBeInstantiated = this.findDesktopViewsToBeInstantiated(selector);
        var that = this;
        desktopViewsToBeInstantiated.forEach(function (entry) {
            that.instantiateDesktopViews(entry);
        });
    }

    findDesktopViewsToBeInstantiated(selector) {
        var result = [];

        var desktopClass = this;
        $(selector + ' *[data-class]').each(function () {
            var $this = $(this);
            var className = $this.data('class');
            if (className) {
                let options = $this.data('options');

                // check whether id is available, otherwise create an unique id for element for later selector
                if (!$this.attr('id')) {
                    var newId = className + desktopClass.elementsIndex;
                    while ($('#' + newId).length) {
                        desktopClass.elementsIndex++;
                        newId = className + desktopClass.elementsIndex;
                    }
                    $this.attr('id', className + desktopClass.elementsIndex);
                }
                desktopClass.elementsIndex++;

                var parentView = null;

                var parentElement = this.parentNode;
                while( parentElement != document.body ) {
                    var view = $(parentElement).view();
                    if( view ) {
                        parentView = view;
                        break;
                    }
                    parentElement = parentElement.parentNode;
                }

                if (!parentView) {
                    parentView = desktopClass.desktopView;
                }

                var entry = {
                    $node: $this,
                    name: this.id,
                    className: className,
                    options: options,
                    parentView: parentView
                };

                entry.options = (entry.options && entry.options.length ? entry.options[0] : entry.options) || {};
                entry.options.selector = '#'+$this.attr('id');

                delete entry.options.class;

                result.push(entry);
                $this.removeAttr('data-options');
            } else {
            }
        });
        return result;
    }

    instantiateDesktopViews(entry:any) {

        var overwriteDom = false;
        var doNotCreateSubviewList = ["ProgressbarView", "RoundContainerView", "TimelineWidget", "TextLinkView", "TextBoxView"];
        if (doNotCreateSubviewList.indexOf(entry.className) !== -1 ){
            overwriteDom = true;
        }

        switch (entry.className){
            case 'ChunkAreaView':
                entry.$node.attr('id', '#chunkPickerView');
                break;
            default:
                var className = entry.className || 'View';
                var classClass = Vf[className] || VfWidgets[className] || SrvgCore[className];
                var controllerClass = Vf[className + 'Controller'] || VfWidgets[className + 'Controller'] || SrvgCore[className + 'Controller'] || null;

                if (entry.$node && entry.$node.height() && !entry.options.height){
                    entry.options.height = entry.$node.height()+'px';
                }

                // put all widgets in one group, except widget is initialised with default widget group
                if (className.indexOf("Widget") != -1 && typeof entry.options.widgetGroup === "undefined"){
                    entry.options.widgetGroup = srvg.widgets.widget_group;
                }

                var options = entry.options;
                options.template = app.templateEngine.template(className);

                if (classClass){
                    var subView = new classClass(options);
                    // destroy the widgets for inactivity
                    app.inactivityController.addSubscriberForEvent(subView, TimeoutEvent);

                    entry.parentView.addSubView(subView, entry.$node, true, overwriteDom);
                }else{
                    console.error('Can not create class for "' + entry.className+'". Please check spelling or whether class exists. ');
                }

                if (controllerClass) {
                    var controller = new controllerClass({subscribeToAllEvents: true, viewForController: subView});

                    // destroy the widgets for inactivity
                    app.inactivityController.addSubscriberForEvent(controller, TimeoutEvent);

                    //console.log("create controller", controller, "with subview", subView);
                    //console.log("app.timelineController", app.timelineController,  app.timelineController.addSubscriberForEvent);
                    //app.timelineController.addSubscriberForEvent(this.chunkIndikatorViewController, AuthorityCodeChangeEvent);
                    //app.timelineController.addSubscriberForEvent(controller, PhaseChangeEvent);

                } else {
                    this.log("can not create controller for", className);
                }
                break;
        }

    }

}

